import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function Currency(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="CurrencyIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#C0E6CB" />
        <path
          d="M13.8333 13.0833C11.9416 12.5917 11.3333 12.0833 11.3333 11.2917C11.3333 10.3833 12.1749 9.75 13.5833 9.75C15.0666 9.75 15.6166 10.4583 15.6666 11.5H17.5083C17.4499 10.0667 16.5749 8.75 14.8333 8.325V6.5H12.3333V8.3C10.7166 8.65 9.4166 9.7 9.4166 11.3083C9.4166 13.2333 11.0083 14.1917 13.3333 14.75C15.4166 15.25 15.8333 15.9833 15.8333 16.7583C15.8333 17.3333 15.4249 18.25 13.5833 18.25C11.8666 18.25 11.1916 17.4833 11.0999 16.5H9.2666C9.3666 18.325 10.7333 19.35 12.3333 19.6917V21.5H14.8333V19.7083C16.4583 19.4 17.7499 18.4583 17.7499 16.75C17.7499 14.3833 15.7249 13.575 13.8333 13.0833Z"
          fill="#539868"
        />
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default Currency;
